import { Routes, Route } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import Dashboard from "./Dashboard";
import ManageAbout from "./pages/ManageAbout";
import ManageContact from "./pages/ManageContact";
import ManageHome from "./pages/ManageHome";
import ManageBlogs from "./pages/ManageBlogs";
import ManagePortfolio from "./pages/ManagePortfolio";
import ManageServices from "./pages/ManageServices";

export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="pages/home" element={<ManageHome />} />
        <Route path="pages/about" element={<ManageAbout />} />
        <Route path="pages/contact" element={<ManageContact />} />
        <Route path="pages/blogs" element={<ManageBlogs />} />
        <Route path="pages/portfolio" element={<ManagePortfolio />} />
        <Route path="pages/services" element={<ManageServices />} />
      </Route>
    </Routes>
  );
}